var defaultTableLength =
  document.getElementById('view-data:TableLength') !== null
    ? document.getElementById('view-data:TableLength').value
    : 5; // need to catch text values this way

export default {
  install(Vue) {
    Vue.prototype.tableLength = parseInt(defaultTableLength) || 5;
  },
  defaultTableLength,
};
